module.exports = __webpack_public_path__ + "img/3m.53432b87.png";